import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../../components/common/Logo";
import Avatar from "../../../../components/common/Avatar";
import { useAuth } from "../../../../context/AuthContext";

import {
  LogOut,
  X,
} from "lucide-react";

import {
  CommunityUsersIcon,
  HomeSimpleDoorIcon,
  AwardIcon,
  SettingsIcon,
  StreamIcon,
  StreamMenuIcon,
  SubscriptionIcon,
} from "../../../assets/images";

const API_ROOT = (
  process.env.REACT_APP_API_URL || "http://localhost:5000/api"
).replace("/api", "");

const mainNavItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: HomeSimpleDoorIcon,
  },
  {
    id: "users",
    label: "Users",
    path: "/admin/users",
    icon: CommunityUsersIcon,
  },
  {
    id: "subscriptions",
    label: "My Subscriptions",
    path: "/admin/subscriptions",
    icon: SubscriptionIcon,
  },
  {
    id: "community",
    label: "Community",
    path: "/admin/community",
    icon: CommunityUsersIcon,
  },
  {
    id: "challenges",
    label: "Challenges",
    path: "/admin/challenges",
    icon: AwardIcon,
  },
  {
    id: "content-management",
    label: "Content Management",
    path: "/admin/content-management",
    icon: StreamIcon,
  },
  {
    id: "faith-stream",
    label: "Faith Stream",
    path: "/admin/faith-stream",
    icon: StreamMenuIcon,
  },
  {
    id: "settings",
    label: "Settings",
    path: "/admin/settings",
    icon: SettingsIcon,
  },
];


const Sidebar = ({ onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Dummy User
  // const user = {
  //   name: "Admin User",
  //   role: "admin",
  //   avatar: "",
  // };

  const isActive = (path) => {
    // For Faith Stream, also activate when on categories path
    if (path === "/admin/faith-stream") {
      return location.pathname === "/admin/faith-stream" ||
        location.pathname === "/admin/categories";
    }
    return location.pathname === path;
  };

  const handleLogout = async () => {
    localStorage.removeItem("isAdminLogin");
    localStorage.removeItem("adminEmail");
    await logout();
    navigate("/login");
    //navigate("/");
  };


  const handleNav = (path) => {
    navigate(path);
    onClose?.();
  };

  return (
    <aside
      className="
        w-[320px]
        sm:w-[340px]
        lg:w-[300px]
        xl:w-[350px]
        h-screen
        bg-white
        flex flex-col
        border-r border-gray-100
        flex-shrink-0
        overflow-y-auto
      "
    >
      {/* Logo */}
      <div className="flex items-center justify-between px-4 py-6 flex-shrink-0">
        <div className="flex-1 flex justify-center">
          <Logo size={110} />
        </div>

        <button
          onClick={onClose}
          className="lg:hidden w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
        >
          <X size={20} stroke="#6B7280" />
        </button>
      </div>

      <div className="border-t border-[#00000026] mx-8 flex-shrink-0" />

      {/* Navigation */}
      <div className="px-8 pt-8 flex-shrink-0">
        <p className="text-[13.67px] font-medium text-[#757575] tracking-[2px] uppercase mb-2 px-3">
          Main
        </p>

        <nav className="flex flex-col gap-1">
          {mainNavItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNav(item.path)}
              className={`flex items-center gap-3 px-4 py-[17px] rounded-xl text-[16px] font-medium w-full text-left transition-all duration-150 ${isActive(item.path)
                  ? "bg-[#1F3A60] text-white"
                  : "text-[#757575] hover:bg-gray-50"
                }`}
            >
              <img
                src={item.icon}
                alt={item.label}
                className={`
                  object-contain
                  flex-shrink-0
                  transition-all duration-150
                  ${isActive(item.path)
                    ? "brightness-0 invert"
                    : "opacity-70"
                  }
                `}
              />

              <span className="flex-1">{item.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* User Section */}
      <div className="mt-auto">
        <div className="border-t border-gray-200 mx-8 flex-shrink-0" />

        <div className="px-8 py-4 flex-shrink-0">
          <div className="flex items-center justify-between py-2">
            <div
              className="flex items-center gap-3 min-w-0 cursor-pointer"
              onClick={() => navigate("/admin/profile")}
            >
              <Avatar
                src={
                  user?.avatar
                    ? user?.avatar.startsWith("/uploads")
                      ? `${API_ROOT}${user?.avatar}`
                      : user?.avatar
                    : "/faithook-app/assets/images/avatar-brother-julian.png"
                }
                alt={user?.name}
                size={36}
                className="flex-shrink-0"
              />

              <div className="min-w-0">
                <p className="text-[13px] font-bold text-gray-800 truncate">
                  {user?.name}
                </p>

                <p className="text-[11px] text-gray-400 capitalize">
                  {user?.role}
                </p>
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center flex-shrink-0"
              title="Logout"
            >
              <LogOut size={16} className="text-gray-400" />
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;